import script from "./DashboardAlertBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardAlertBadge.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardAlertBadge.vue?vue&type=style&index=0&id=e7819b18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7819b18"]])

export default __exports__